import usePluginEntities from "hooks/usePluginEntities";
const usePluggableEntityCollectionGranteeList = () => {
  var _a;
  const pluggableCollectionGranteeList = usePluginEntities("components.collection");
  const collection = pluggableCollectionGranteeList == null ? void 0 : pluggableCollectionGranteeList[0];
  const conditionMet = (collection == null ? void 0 : collection.useCondition) ? collection.useCondition() : true;
  if (!conditionMet) return null;
  return (_a = collection == null ? void 0 : collection.CollectionGranteeList) != null ? _a : null;
};
export default usePluggableEntityCollectionGranteeList;
